/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Material_Price_Reset_HintInputs */

const vi_order_material_price_reset_hint = /** @type {(inputs: Order_Material_Price_Reset_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tách/gộp sẽ tính lại đơn giá theo giá cấu hình, thay cho giá bạn đã sửa.`)
};

/**

* @param {Order_Material_Price_Reset_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_material_price_reset_hint = /** @type {((inputs?: Order_Material_Price_Reset_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Material_Price_Reset_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_material_price_reset_hint(inputs)
});